import { render, staticRenderFns } from "./AttachmentUploadModal.vue?vue&type=template&id=005d0fdd&scoped=true"
import script from "./AttachmentUploadModal.vue?vue&type=script&lang=ts"
export * from "./AttachmentUploadModal.vue?vue&type=script&lang=ts"
import style0 from "./AttachmentUploadModal.vue?vue&type=style&index=0&id=005d0fdd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005d0fdd",
  null
  
)

export default component.exports